import React from 'react';
import Layout from './components/Layout/Layout';
import { Routes, Route } from 'react-router-dom';
import Migration from './components/Migration/Migration';
import Users from './components/Users/Users';
import Feed from './components/Feed/Feed';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import MyTasks from './pages/MyTasks';
import Navigator from './pages/Navigator';
import NavigatorChat from './pages/NavigatorChat';
import Logs from './components/Logs/Logs';
import RequireAuth from './components/common/RequireAuth';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { Toaster } from './components/ui/sonner';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <Layout>
        <Routes>
          <Route path="/navigator" element={<RequireAuth><Navigator /></RequireAuth>} />
          <Route path="/navigator-chat" element={<RequireAuth><NavigatorChat /></RequireAuth>} />
          <Route path="/feed" element={<RequireAuth><Feed /></RequireAuth>} />
          <Route path="/migration" element={<RequireAuth><Migration /></RequireAuth>} />
          <Route path="/users" element={<RequireAuth><Users /></RequireAuth>} />
          <Route path="/logs" element={<RequireAuth><Logs /></RequireAuth>} />
          <Route path="/projects" element={<RequireAuth><Projects /></RequireAuth>} />
          <Route
            path="/projects/:projectId"
            element={
              <RequireAuth>
                <ProjectDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/my-tasks"
            element={
              <RequireAuth>
                <MyTasks />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/profile"
            element={
              <RequireAuth>
                <Profile />
              </RequireAuth>
            }
          />
          <Route
            path="/settings"
            element={
              <RequireAuth>
                <Settings />
              </RequireAuth>
            }
          />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
        </Routes>
      </Layout>
      <Toaster />
    </ErrorBoundary>
  );
};

export default App;
